export type RespostaItem = {
    id: number | null
    resposta: string
    ativo: boolean
}

export type RespostasPersonalizadasIzzaModel = {
    boasVindas: RespostaItem
    aceito: RespostaItem
    retiradoBalcao: RespostaItem
    saiuParaEntrega: RespostaItem
    emProducao: RespostaItem
    emProducaoRetirada: RespostaItem
    entregue: RespostaItem
    horarioFuncionamento: RespostaItem
    taxaEntrega: RespostaItem
    contato: RespostaItem
    cardapio: RespostaItem
    formaPagamento: RespostaItem
    tempoEntrega: RespostaItem
    situacaoPedidoNormal: RespostaItem
    situacaoPedidoAtrasado: RespostaItem
    cancelamento: RespostaItem
    alteracao: RespostaItem
    modoIzza: number
}

const respostaItemInicial: RespostaItem = { id: null, resposta: "", ativo: false }

export const RespostasPersonalizadasIzzaInicial: RespostasPersonalizadasIzzaModel = {
    boasVindas: { ...respostaItemInicial },
    aceito: { ...respostaItemInicial },
    retiradoBalcao: { ...respostaItemInicial },
    saiuParaEntrega: { ...respostaItemInicial },
    emProducao: { ...respostaItemInicial },
    emProducaoRetirada: { ...respostaItemInicial },
    entregue: { ...respostaItemInicial },
    horarioFuncionamento: { ...respostaItemInicial },
    taxaEntrega: { ...respostaItemInicial },
    contato: { ...respostaItemInicial },
    cardapio: { ...respostaItemInicial },
    formaPagamento: { ...respostaItemInicial },
    tempoEntrega: { ...respostaItemInicial },
    situacaoPedidoNormal: { ...respostaItemInicial },
    situacaoPedidoAtrasado: { ...respostaItemInicial },
    cancelamento: { ...respostaItemInicial },
    alteracao: { ...respostaItemInicial },
    modoIzza: 0,
}

export type CampoRespostaIzza = keyof Omit<RespostasPersonalizadasIzzaModel, "modoIzza">
